import { useEffect } from 'react';
import ContactNavbar from './components/ContactNavbar';
import ContactHero from './components/ContactHero';
import ContactServices from './components/ContactServices';
import QuoteEstimator from './components/QuoteEstimator';
import AvailabilityCalendar from './components/AvailabilityCalendar';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import ContactMap from './components/ContactMap';
import VIPEnquiryForm from './components/VIPEnquiryForm';
import Footer from '../home/components/Footer';

export default function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <ContactNavbar />
      <ContactHero />
      <ContactServices />
      <AvailabilityCalendar />
      <div id="quote-estimator-section">
        <QuoteEstimator />
      </div>

      {/* VIP Enquiry Section */}
      <section
        className="py-24 px-6 lg:px-12 relative overflow-hidden"
        style={{
          background: 'linear-gradient(160deg, #0f0a03 0%, #1e1408 50%, #0f0a03 100%)',
        }}
      >
        {/* Ambient gold glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-10 pointer-events-none"
          style={{ background: 'radial-gradient(circle, #d4a017 0%, transparent 70%)' }}
        />
        <div className="max-w-3xl mx-auto relative z-10">
          <div className="text-center mb-12">
            <p className="text-amber-500 text-xs tracking-[0.4em] uppercase font-medium mb-3">
              Premium Experience
            </p>
            <h2
              className="text-4xl lg:text-5xl font-light text-amber-100 mb-4"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              VIP Event Packages
            </h2>
            <div className="flex items-center justify-center gap-4 mb-5">
              <div className="h-px w-16 bg-gradient-to-r from-transparent to-amber-500" />
              <i className="ri-vip-crown-2-fill text-amber-400 text-lg" />
              <div className="h-px w-16 bg-gradient-to-l from-transparent to-amber-500" />
            </div>
            <p className="text-amber-200/50 text-sm max-w-lg mx-auto leading-relaxed">
              Bespoke, white-glove service for those who demand nothing but the extraordinary.
              Fill in the form below and our VIP concierge will be in touch within 4 hours.
            </p>
          </div>
          <VIPEnquiryForm />
        </div>
      </section>

      {/* Main content */}
      <section className="py-20 px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="flex flex-col gap-6">
              <div>
                <p className="text-amber-600 text-xs tracking-[0.35em] uppercase font-medium mb-2">
                  We're Here For You
                </p>
                <h2
                  className="text-3xl font-light text-stone-800 mb-3"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  Let's Plan Your Event
                </h2>
                <div className="w-14 h-px bg-gradient-to-r from-amber-400 to-transparent mb-5" />
                <p className="text-stone-500 text-sm leading-relaxed">
                  Whether you're planning a wedding, corporate event, birthday celebration or intimate gathering —
                  House of FMR is here to make it extraordinary. Reach out via any of the channels below or fill in
                  the enquiry form and we'll be in touch within 24 hours.
                </p>
              </div>
              <ContactInfo />
            </div>
            <div>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      <ContactMap />
      <Footer />
    </div>
  );
}
